/* =============================================================================
 * Criacao de elementos.
 *
 * Todo componente do app e' uma funcao que devolve HTMLElement. Nada de
 * innerHTML: texto sempre entra por textContent, o que da' protecao contra XSS
 * por construcao. A unica excecao do app inteiro e' ui/componentes/htmlSeguro.js,
 * que sanitiza o regulamento da competicao (HTML livre digitado por humanos).
 * ========================================================================== */

const SVG_NS = 'http://www.w3.org/2000/svg';

/**
 * h('div', { class: 'x', onclick: fn }, [filhos])
 *
 * - `class`, `id`, `href`... viram atributos
 * - `onclick`, `oninput`... viram addEventListener
 * - `dataset: { id: 1 }` vira data-id="1"
 * - `style: { color: 'red' }` vira estilo inline
 * - filhos falsy sao ignorados, o que permite `condicao && elemento`
 */
export function h(tag, props = null, filhos = null) {
    const el = document.createElement(tag);
    aplicarProps(el, props);
    anexar(el, filhos);
    return el;
}

export function svg(tag, props = null, filhos = null) {
    const el = document.createElementNS(SVG_NS, tag);
    aplicarProps(el, props, true);
    anexar(el, filhos);
    return el;
}

function aplicarProps(el, props, ehSvg = false) {
    if (!props) return;
    for (const [chave, valor] of Object.entries(props)) {
        if (valor === null || valor === undefined || valor === false) continue;

        if (chave.startsWith('on') && typeof valor === 'function') {
            el.addEventListener(chave.slice(2), valor);
        } else if (chave === 'dataset') {
            Object.assign(el.dataset, valor);
        } else if (chave === 'style' && typeof valor === 'object') {
            Object.assign(el.style, valor);
        } else if (chave === 'texto') {
            el.textContent = String(valor);
        } else if (valor === true) {
            el.setAttribute(chave, '');
        } else if (!ehSvg && chave in el && chave !== 'list' && chave !== 'form') {
            el[chave] = valor;
        } else {
            el.setAttribute(chave, String(valor));
        }
    }
}

function anexar(el, filhos) {
    if (filhos === null || filhos === undefined || filhos === false) return;

    if (Array.isArray(filhos)) {
        for (const filho of filhos) anexar(el, filho);
        return;
    }
    if (filhos instanceof Node) {
        el.appendChild(filhos);
        return;
    }
    //Numero 0 e' conteudo legitimo (placar!), booleano nao e'.
    if (typeof filhos === 'boolean') return;
    el.appendChild(document.createTextNode(String(filhos)));
}

export function frag(filhos) {
    const f = document.createDocumentFragment();
    anexar(f, filhos);
    return f;
}

export function limpar(el) {
    el?.replaceChildren();
    return el;
}

/** Troca todo o conteudo de uma so' vez - evita reflow intermediario. */
export function render(container, ...filhos) {
    container.replaceChildren(frag(filhos));
    return container;
}

/**
 * Delegacao de evento: um unico listener no container atende itens que ainda
 * nem existem. Evita pendurar centenas de listeners numa lista longa.
 */
export function delegar(container, evento, seletor, manipulador) {
    const ouvinte = (ev) => {
        const alvo = ev.target.closest(seletor);
        if (alvo && container.contains(alvo)) manipulador(ev, alvo);
    };
    container.addEventListener(evento, ouvinte);
    return () => container.removeEventListener(evento, ouvinte);
}
